export function getIdFromName(object, value) {
  const values = Object.values(object);
  const keys = Object.keys(object);
  const index = values.indexOf(value);
  return index !== -1 ? keys[index] : null;
}

export function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

// Convert excel date to javascript date
export function excelDateToJSDate(serial) {
  if (serial) {
    var date = new Date((serial - 25569) * 86400000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return day + "." + month + "." + year;
  }
  return "";
}

// format string. remove accents, replace spaces with dashes and lowercase
export function formatString(string) {
  if (string) {
    return string
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "");
  }
  return "";
}
// to title case function for strings (first letter of each word is capitalized)
export function capitalizeWords(string) {
  return string.toLowerCase().replace(/(?:^|\s|[-'’])(\S)/gu, function (match) {
    return match.toUpperCase();
  });
}
